import { styled } from '@mui/material/styles';
import React from 'react';

import { AppBar, Box, IconButton, Toolbar as MuiToolbar, useMediaQuery, useTheme } from '@mui/material';

import { useThemeState } from 'contexts/theme/ThemeContext';
import { AquaSpecies } from 'types/shared/aqua-species.type';
import { ReactComponent as AquaXcel } from '../assets/aqua-xcel-icon.svg';
import { ReactComponent as Ewos } from '../assets/ewos-toolbar-icon.svg';
import { ReactComponent as HamburgerMenu } from '../assets/hamburger-menu.svg';

const StyledDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  padding: theme.spacing(0, 0, 0, 0),

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 6, 0, 6),
  },
}));

const StyledToolBar = styled(MuiToolbar)(({ theme }) => ({
  justifyContent: 'flex-end',
}));

type ToolbarProps = {
  handleDrawerToggle: () => void;
};

const Toolbar: React.FC<ToolbarProps> = ({ handleDrawerToggle }) => {
  // const history = useHistory();
  const theme = useTheme();
  const { aquaSpecies } = useThemeState();

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const openMobileMenu = () => {
    handleDrawerToggle();
  };

  return (
    <StyledDiv>
      <AppBar elevation={0} variant="outlined" color="transparent" position="static">
        {isDesktop ? (
          <StyledToolBar sx={{ m: '10px 0', justifyContent: 'flex-end' }}>
            {aquaSpecies === 'shrimp' ? <AquaXcel /> : <Ewos />}
          </StyledToolBar>
        ) : (
          <StyledToolBar sx={{ m: '10px 0', justifyContent: 'space-between', paddingBottom: 6 }}>
            <Box display={{ xs: 'block', md: 'none' }}>
              <IconButton color="inherit" aria-label="open drawer" onClick={openMobileMenu} title="Menu">
                <HamburgerMenu width={35} height={35} />
              </IconButton>
            </Box>
            {aquaSpecies === AquaSpecies.shrimp ? <AquaXcel /> : <Ewos />}
          </StyledToolBar>
        )}
      </AppBar>
    </StyledDiv>
  );
};

export default Toolbar;
